// src/services/elevationService.js
// FlowSense MOW+ — ground elevation (TessaDEM) API client (backend: routes/elevation.js)
import api from './api';

const unwrap = (res) => {
  const body = res?.data;
  if (body && body.success === false) throw new Error(body.message || 'Elevation request failed');
  return body?.data ?? body;
};

/** { job, coverage } */
export const fetchElevationStatus = async ({ signal } = {}) => unwrap(await api.get('/elevation/status', { signal }));
/** scope ⊂ ['assets','road_segments','pipelines','sensors','road_sub_assets']; force re-fetches everything. */
export const startElevationBackfill = async ({ scope, force = false } = {}) => unwrap(await api.post('/elevation/backfill', { scope, force }));
export const cancelElevationBackfill = async () => unwrap(await api.post('/elevation/backfill/cancel'));
/** { surveyed_elevation_m, ground_elevation_m, source, fetched_at, profile, terrain } */
export const fetchAssetElevation = async (assetId, { signal } = {}) =>
  unwrap(await api.get(`/elevation/assets/${encodeURIComponent(assetId)}`, { signal }));
export const refreshAssetElevation = async (assetId) =>
  unwrap(await api.post(`/elevation/assets/${encodeURIComponent(assetId)}/refresh`));
/** points: [{lat,lng}] (≤512) → [{lat,lng,elevation_m}] */
export const lookupElevations = async (points) => unwrap(await api.post('/elevation/lookup', { points }));
